import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  TextInput,
  useNotify,
  useRefresh,
  useRecordContext,
  useDataProvider,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { Button } from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";

function SyncNowButton() {
  const record = useRecordContext<any>();
  const dp = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Button
      size="small"
      startIcon={<SyncIcon />}
      onClick={async () => {
        try {
          await (dp as any).custom(`calendar-feeds/${record.id}/sync`, { method: "POST" });
          notify("Sync angestoßen.", { type: "info" });
          refresh();
        } catch (e: any) {
          notify(e?.message ?? "Sync fehlgeschlagen", { type: "warning" });
        }
      }}
    >
      Sync
    </Button>
  );
}

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export function CalendarFeedList(props: any) {
  return (
    <List
      {...props}
      actions={<ListActions />}
      filters={[<TextInput source="q" label="Suche" alwaysOn key="q" />]}
      perPage={50}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="scope" />
        <TextField source="sync_mode" />
        <BooleanField source="is_active" />
        <DateField source="last_synced_at" showTime />
        <TextField source="last_error" />
        <SyncNowButton />
      </Datagrid>
    </List>
  );
}
